const SRCSET_WIDTHS = [320, 640, 1024, 1600] as const;

export function variantUrl(url: string, width: number): string {
  const dot = url.lastIndexOf(".");
  const stem = dot !== -1 ? url.slice(0, dot) : url;
  return `${stem}_w${width}.webp`;
}

export function buildImageSrcSet(src: string | null | undefined): string | undefined {
  if (!src) return undefined;
  if (!src.startsWith("/storage/")) return undefined;
  if (/_w\d+\.webp$/.test(src)) return undefined;
  if (src.includes("_thumb.")) return undefined;
  return SRCSET_WIDTHS.map((w) => `${variantUrl(src, w)} ${w}w`).join(", ");
}
